import React from 'react';
import { Link } from 'react-router-dom';
import { FaTable } from 'react-icons/fa';

const TimetableStatusCard = ({ timetable, link }) => {
  if (!timetable) return null;

  return (
    <div className="col-xl-6 col-lg-6 col-md-12 mb-4">
      <div className="card dash-card h-100">
        <div className="dash-card-header">
          <span className="dash-card-header-title">
            <FaTable />
            <span>Timetable</span>
          </span>
          {link && <Link to={link} className="dash-view-link">Manage</Link>}
        </div>
        <div className="dash-card-body d-flex align-items-center gap-3">
          <span className={`dash-pill ${timetable.uploaded ? 'dash-pill-success' : 'dash-pill-danger'}`}>
            {timetable.uploaded ? 'Uploaded' : 'Not Uploaded'}
          </span>
          {timetable.status && <span className="small text-muted">Status: {timetable.status}</span>}
        </div>
      </div>
    </div>
  );
};

export default TimetableStatusCard;
